import { Map } from 'immutable';
import { actionTypes } from './actions';

export const initialState = Map({
  selectedPaymentID: null
});

const paymentsView = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_SELECTED_PAYMENT_ID:
      return state.set('selectedPaymentID', action.payload);
    default:
      return state;
  }
};

export default paymentsView;